export const THAI_MASSAGE = {
  en: {
    seo: {
      title: "Pregnancy & Postnatal Massage at Home | Schiedam & Rotterdam | Women's Den",
      description: "Pregnancy and postnatal Thai massage in your own home in and around Schiedam. Slow, attentive full-body care during pregnancy and after birth, offered in English.",
    },
    hero: {
      eyebrow: "At your home — you don't have to go anywhere",
      title: "Pregnancy & Postnatal Thai Massage",
      sub: "Full-body massage and restorative care in your own home — during pregnancy and after birth.",
      intro: "A 90- or 120-minute Thai massage with particular attention to the pelvis and lower body, back, neck and shoulders — and space for you to rest and receive while your body carries a pregnancy or adjusts after birth.",
      facts: ["From week 14 of pregnancy", "From ~6 weeks after birth", "90 or 120 minutes", "At your home", "In & around Schiedam"],
      options: [{ label: "90 minutes", price: "€120" }, { label: "120 minutes", price: "€140" }],
      primaryCta: "Book a massage",
      secondaryCta: "See the options",
    },
    care: {
      title: "Some care for the mother",
      p1: "Pregnancy and birth ask a great deal of the body. And once your baby arrives, your days quickly fill with feeding, holding, carrying, interrupted sleep and learning how to care for this new little person.",
      p2: "Your own body can easily move into the background.",
      pull: "After birth, so much care moves towards the baby. This is time for care to return to your body.",
      p3: "Postpartum Thai Massage gives you a substantial period of time in which you are the one being attended to.",
    },
    home: {
      heading: "I come to you",
      title: "In the comfort of your own home",
      p1: "You don't need to pack a baby bag, organise feeding around an appointment or travel across town for your massage.",
      p2: "I bring the massage mat to you.",
      p3: "All you need is enough clear floor space for the mat and comfortable clothes to wear.",
      p4: "This is part of what makes the treatment particularly appropriate during pregnancy and the postpartum months.",
    },
    feels: {
      title: "What does Thai massage feel like?",
      p1: "Unlike an oil massage on a massage table, Thai massage is received fully clothed on a comfortable massage mat on the floor.",
      p2: "I work gradually through the whole body, from your feet to your head, using rhythmic pressure, gentle movement and supported stretches.",
      p3: "The treatment is adapted to you and to how your body is feeling that day.",
      p4: "You simply wear loose, comfortable clothing that allows you to move easily.",
    },
    testimonials: {
      heading: "What women say",
      items: [
        { text: "I didn't realise I was holding so much until the end of the massage, and I felt so much more in my body. Soft and able to breathe more easefully.\n\nThere is so much care in the massage — rocking, kneading, shaking. I highly recommend it for deeply nourishing postpartum care.", name: "Kate M." },
      ],
    },
    wholeBody: {
      title: "From feet to head",
      p1: "This isn't a short treatment of one problem area.",
      p2: "I work with your whole body, while giving particular attention to places that may be carrying more during pregnancy, or after birth and in the early weeks of motherhood.",
      p3: "There is particular attention to the pelvis and lower body, as well as the back, neck and shoulders.",
      p4: "The longer treatment also gives us enough time not to rush from one part of the body to another.",
    },
    quiet: {
      title: "Time when you don't have to attend to everything",
      p1: "The early months with a baby can involve an enormous amount of physical and mental attention.",
      pull: "For the duration of your massage, there is nothing you need to achieve. You can lie down, be quiet and receive.",
    },
    baby: {
      title: "Can my baby be there?",
      p1: "Ideally, if possible, someone else can care for your baby during the massage. This allows you to have the treatment time more completely for yourself.",
      p2: "But that isn't always possible with a young baby. Your baby can be nearby if necessary.",
      p3: "If your baby needs feeding, settling or your attention, we can pause.",
      closing: "You don't need the circumstances to be perfect before you can receive care.",
    },
    when: {
      title: "When can I book?",
      p1: "Postpartum Thai Massage is generally offered from around six weeks after birth. During pregnancy, massage is possible from around week 14, always adapted to your trimester.",
      p2: "If your recovery has been complicated, you have ongoing medical concerns, significant pain, infection, problems with healing, or you're uncertain whether massage is appropriate for you, please check with your midwife, GP or other healthcare professional first.",
    },
    therapist: {
      heading: "Your massage therapist",
      qual: "Thai Massage Therapist — School of Thai Yoga Massage, 2011",
      body: "I'm Irida Hysenbelli, founder of Women's Den. Alongside my work with women around pregnancy, birth and motherhood, I have practised Thai massage for many years — slow, attentive bodywork that asks for trust on both sides. Coming to your home means meeting you where your life actually is: your floor, your rhythm, your baby nearby if needed.",
      link: "More about Irida",
    },
    faq: {
      heading: "Questions",
      items: [
        { q: "When after birth can I book?", a: "From around six weeks postpartum. If you've had complications, ongoing medical concerns or you're uncertain whether massage is appropriate, please check with your midwife, GP or healthcare professional first." },
        { q: "Can I book during pregnancy?", a: "Yes. Pregnancy massage is offered from around week 14 and is always adapted to your trimester — fully clothed, supported by cushions, at your pace." },
        { q: "Do I need to provide anything?", a: "Just enough clear floor space for the massage mat and comfortable clothes for yourself. I bring the massage mat." },
        { q: "Do I need to undress?", a: "No. Thai massage is received fully clothed. Wear loose, comfortable clothing that allows you to move easily." },
        { q: "Can my baby be present?", a: "Yes, if necessary. Ideally someone else cares for your baby during the treatment so you can receive the massage without interruption, but your baby can remain nearby." },
        { q: "What if I need to feed my baby?", a: "We pause." },
        { q: "Is travel included?", a: "Yes, for home visits in and around Schiedam." },
      ],
    },
    final: {
      title: "Time for care to return to your body.",
      heading: "Thai Massage at Home",
      options: [{ label: "90 minutes", price: "€120" }, { label: "120 minutes", price: "€140" }],
      line1: "From week 14 of pregnancy · From around 6 weeks after birth",
      line2: "Home visit in and around Schiedam · Travel included · Fully clothed · Massage mat provided",
      cta: "Book your massage",
      secondary: "Have a question? Get in touch",
    },
  },
  nl: {
    seo: {
      title: "Zwangerschapsmassage & postpartum massage aan huis | Schiedam & Rotterdam",
      description: "Zwangerschapsmassage en postpartum Thaise massage bij jou thuis, in en rond Schiedam en Rotterdam. Langzame, aandachtige verzorging van het hele lichaam tijdens de zwangerschap en na de bevalling — aangeboden in het Engels.",
    },
    hero: {
      eyebrow: "Bij jou thuis — je hoeft nergens heen",
      title: "Thaise Massage tijdens Zwangerschap & Postnataal",
      sub: "Een Thaise massage voor het hele lichaam, bij jou thuis — tijdens de zwangerschap of in de periode na de bevalling.",
      intro: "Een behandeling van 90 of 120 minuten, met extra aandacht voor het bekken en onderlichaam, de rug, nek en schouders — en vooral tijd om te rusten en verzorgd te worden terwijl je lichaam tijdens de zwangerschap verandert of herstelt na de geboorte.",
      facts: ["Vanaf week 14 van de zwangerschap", "Vanaf ±6 weken na de bevalling", "90 of 120 minuten", "Bij jou thuis", "In en rond Schiedam"],
      options: [{ label: "90 minuten", price: "€120" }, { label: "120 minuten", price: "€140" }],
      primaryCta: "Boek een massage",
      secondaryCta: "Bekijk de opties",
    },
    care: {
      title: "Ook de moeder heeft zorg nodig",
      p1: "Zwangerschap en bevalling vragen veel van je lichaam. En zodra je baby er is, vullen de dagen zich snel met voeden, vasthouden, dragen, onderbroken slaap en ontdekken wat je baby nodig heeft.",
      p2: "Je eigen lichaam kan daarbij gemakkelijk op de achtergrond raken.",
      pull: "Na de geboorte gaat zoveel aandacht en zorg naar je baby. Deze massage is een moment waarop die zorg ook weer naar jou mag gaan.",
      p3: "Postnatale Thaise massage geeft je 90 of 120 minuten waarin jij degene bent voor wie gezorgd wordt.",
    },
    home: {
      heading: "Ik kom naar jou toe",
      title: "In het comfort van je eigen huis",
      p1: "Je hoeft geen luiertas in te pakken, voedingen rond een afspraak te plannen of de stad door te reizen voor je massage.",
      p2: "Ik breng de massagemat mee.",
      p3: "Alles wat je nodig hebt, is voldoende vrije vloerruimte voor de mat en comfortabele kleding.",
      p4: "Juist daarom is deze behandeling zo prettig tijdens de zwangerschap en in de postnatale maanden.",
    },
    feels: {
      title: "Hoe voelt Thaise massage?",
      p1: "Anders dan bij een oliemassage op een massagetafel blijf je tijdens een Thaise massage volledig gekleed en lig je op een comfortabele massagemat op de vloer.",
      p2: "Ik werk geleidelijk door het hele lichaam, van je voeten tot je hoofd, met ritmische druk, zachte bewegingen en begeleide stretches.",
      p3: "De behandeling wordt afgestemd op jou en op hoe je lichaam die dag aanvoelt.",
      p4: "Je draagt gewoon losse, comfortabele kleding waarin je gemakkelijk kunt bewegen.",
    },
    testimonials: {
      heading: "Wat vrouwen zeggen",
      items: [
        { text: "Pas aan het einde van de massage realiseerde ik me hoeveel spanning ik vasthield. Ik voelde me daarna veel meer aanwezig in mijn lichaam — zachter en alsof ik gemakkelijker kon ademen.\n\nEr zit zoveel zorg in de massage — wiegen, kneden, schudden. Ik kan het van harte aanbevelen als een heel verzorgende vorm van postnatale zorg.", name: "Kate M." },
      ],
    },
    wholeBody: {
      title: "Van voeten tot hoofd",
      p1: "Dit is geen korte behandeling van één probleemgebied.",
      p2: "Ik werk met je hele lichaam, met extra aandacht voor gebieden die tijdens de zwangerschap en in de periode na de bevalling vaak veel te verduren krijgen.",
      p3: "Daarbij besteed ik bijzondere aandacht aan het bekken en onderlichaam, en aan de rug, nek en schouders.",
      p4: "De langere behandeling geeft ons de tijd om rustig door het hele lichaam te werken, zonder van het ene lichaamsdeel naar het andere te hoeven haasten.",
    },
    quiet: {
      title: "Even nergens voor hoeven zorgen",
      p1: "De eerste maanden met een baby kunnen enorm veel van je vragen, zowel lichamelijk als mentaal.",
      pull: "Tijdens je massage hoef je niets te doen of ergens voor te zorgen. Je kunt gaan liggen, stil zijn en je laten verzorgen.",
    },
    baby: {
      title: "Kan mijn baby erbij zijn?",
      p1: "Als het mogelijk is, is het fijn als iemand anders tijdens de massage voor je baby kan zorgen. Zo heb je de behandeltijd zoveel mogelijk voor jezelf.",
      p2: "Maar met een jonge baby is dat niet altijd mogelijk. Je baby kan indien nodig dichtbij blijven.",
      p3: "Als je baby gevoed of getroost moet worden of je aandacht nodig heeft, pauzeren we gewoon.",
      closing: "De omstandigheden hoeven niet perfect te zijn om tijd en zorg voor jezelf te mogen ontvangen.",
    },
    when: {
      title: "Wanneer kan ik boeken?",
      p1: "Postnatale Thaise massage is over het algemeen mogelijk vanaf ongeveer zes weken na de bevalling. Tijdens de zwangerschap kun je vanaf ongeveer week 14 boeken, waarbij de massage altijd wordt aangepast aan de fase van je zwangerschap.",
      p2: "Als je herstel na de bevalling gecompliceerd is geweest, je medische klachten of veel pijn hebt, een infectie of problemen met wondgenezing hebt, of twijfelt of massage op dit moment geschikt voor je is, overleg dan eerst met je verloskundige, huisarts of een andere zorgverlener.",
    },
    therapist: {
      heading: "Je massagetherapeut",
      qual: "Thai Massage Therapist — School of Thai Yoga Massage, 2011",
      body: "Ik ben Irida Hysenbelli, oprichter van Women's Den. Naast mijn werk met vrouwen rond zwangerschap, geboorte en moederschap geef ik al vele jaren Thaise massage. Voor mij is het langzaam en aandachtig lichaamswerk, waarin vertrouwen en afstemming belangrijk zijn. Dat ik bij jou thuis kom, betekent ook dat de massage plaatsvindt midden in je echte leven — in je eigen omgeving, in jouw ritme, met je baby dichtbij als dat nodig is.",
      link: "Meer over Irida",
    },
    faq: {
      heading: "Veelgestelde vragen",
      items: [
        { q: "Wanneer na de bevalling kan ik boeken?", a: "Vanaf ongeveer zes weken postnataal. Bij complicaties, medische klachten of twijfel: overleg eerst met je verloskundige, huisarts of zorgverlener." },
        { q: "Kan ik tijdens de zwangerschap boeken?", a: "Ja. Zwangerschapsmassage wordt aangeboden vanaf ongeveer week 14 en is altijd aangepast aan de fase van je zwangerschap — volledig gekleed, ondersteund door kussens, in jouw tempo." },
        { q: "Moet ik thuis iets voorbereiden voor de massage?", a: "Alleen voldoende vrije vloerruimte voor de massagemat en comfortabele kleding voor jezelf. Ik breng de massagemat mee." },
        { q: "Moet ik me uitkleden?", a: "Nee. Thaise massage ontvang je volledig gekleed. Draag losse, comfortabele kleding waarin je gemakkelijk kunt bewegen." },
        { q: "Kan mijn baby aanwezig zijn?", a: "Ja, als dat nodig is. Idealiter zorgt iemand anders voor je baby tijdens de behandeling zodat je de massage ononderbroken kunt ontvangen, maar je baby kan dichtbij blijven." },
        { q: "Wat als ik mijn baby tijdens de massage moet voeden?", a: "Dan pauzeren we." },
        { q: "Zijn de reiskosten inbegrepen?", a: "Ja, voor huisbezoeken in en rond Schiedam." },
      ],
    },
    final: {
      title: "Even tijd waarin er voor jóú gezorgd wordt.",
      heading: "Thaise massage bij jou thuis",
      options: [{ label: "90 minuten", price: "€120" }, { label: "120 minuten", price: "€140" }],
      line1: "Vanaf week 14 van de zwangerschap · Vanaf ongeveer 6 weken na de bevalling",
      line2: "Huisbezoek in en rond Schiedam · Reiskosten inbegrepen · Volledig gekleed · Massagemat inbegrepen",
      cta: "Boek je massage",
      secondary: "Nog een vraag? Neem contact op",
    },
  },
};
